import type { Session } from "@/types/api/program"

export function isSessionLive (session: Session, now = 0): boolean {
  const now_ = now || Date.now()
  return now_ >= session.start && now_ < session.finish
}

export const isSessionExpired = (session: Session, now = 0): boolean =>
  session.finish <= (now || Date.now())
